let Slider;
export default () => ({
	createSlider() {
		Slider = new window.Swiper('.featured-blog__slider', {
			slidesPerView: 1.25,
			speed: 500,
			spaceBetween: 10,
			breakpoints: {
				480: {
					slidesPerView: 1.65,
				},
				640: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1024: {
					spaceBetween: 24,
					slidesPerView: 4,
				},
			},
			navigation: {
				nextEl: '.featured-blog__next-slide',
				prevEl: '.featured-blog__prev-slide',
			},
		});
	},

	init() {
		this.createSlider();
	},
});
